"use strict";
exports.__esModule = true;
var colors = ['#4C566C', '#2DD28D', '#4CA6FF', '#F5B800', '#FF7170', '#BE99FF', '#18DCDC', '#81E487'];
exports["default"] = colors;
